const en = {
  // Navbar
  nav_home: "Home",
  nav_about: "About Tenten-Ojisan",
  nav_services: "Services & Pricing",
  nav_flow: "How It Works",
  nav_testimonials: "Testimonials",
  nav_faq: "FAQ",
  nav_contact: "Contact",
  nav_cta: "Book a Reading",
  nav_subtitle: "Okinawa Name Reading",
  nav_title: "Tenten-Ojisan Divination",

  // Hero
  hero_headline1: "On a quiet island",
  hero_headline2: "in Okinawa,",
  hero_headline3: "he listens to",
  hero_headline4: "the voice of your name.",
  hero_body: "A beloved name reading with a months-long waitlist.\nI visit the island on your behalf every month\nand personally deliver your name to the master.",
  hero_pill1: "No name change needed",
  hero_pill2: "100% online",
  hero_pill3: "Delivered within 1 month",
  hero_pill4: "First 100 per month",
  hero_btn_apply: "Book a Reading",
  hero_btn_services: "View Services",
  hero_scroll: "SCROLL",

  // About
  about_heading: "About Tenten-Ojisan",
  about_intro: "On the tranquil island of <strong>Ikei-jima</strong>, wrapped in Okinawa's gentle sea,\nthere is a man who quietly adds light to each person's name.\nPeople affectionately call him <strong>\"Tenten-Ojisan\"</strong>.",
  about_block1_label: "From Banker to Name Reader",
  about_block1_text: "Tenten-Ojisan was originally a banker.\nThrough dedication, he became the <strong>youngest branch manager</strong> in his company.\nAs he worked with many people, a question arose in his heart.",
  about_block1_quote: "\"Why do some people seem to have the wind at their backs, even when everyone works just as hard?\"",
  about_block1_sub: "That small question became the beginning of a great journey of discovery.",
  about_block2_label: "Ancient Wisdom and a Quiet Revelation",
  about_block2_text: "He devoted every spare moment to studying ancient name-reading texts, carefully researching the stroke counts of traditional characters and the flow of sounds.",
  about_block2_text2: "He came to realize that <strong>\"ten-ten (voiced marks) can quietly harmonize the flow of a name.\"</strong>",
  about_block2_sub: "It was not dramatic magic or a flashy success formula,\nbut a gentle way of making the light already within a person more visible.",
  about_block3_label: "Word of Mouth, Now a 6-Month Wait",
  about_block3_text: "His gentle readings spread purely by word of mouth, and now <strong>requests come from all over Japan</strong>.\nWhether famous or not, he treats every person with the same care.\nHe places his hand on each name and walks alongside that person's life.\nThat is the style of Tenten-Ojisan.",

  // Gallery
  gallery_heading: "Gallery",
  gallery_sub: "Okinawa · Ikei Island",

  // Services
  services_heading: "Services & Pricing",
  services_note1: "※ All fees include the master's reading fee and our on-site proxy service.",
  services_note2: "※ No additional charges. Please feel free to entrust us.",
  services_tab1: "Personal Name",
  services_tab2: "Business Name",
  services_tab3: "Pet Name",
  services_tab1_en: "Personal Name",
  services_tab2_en: "Business Name",
  services_tab3_en: "Pet Name",
  services_tab1_desc: "Gently observing growth, environment, and the movements of the heart, we add the perfect ten-ten to suit you.",
  services_tab2_desc: "A gentle tailwind for new challenges. Softly harmonizing the flow of your business.",
  services_tab3_desc: "For the beloved family member always by your side. We deliver a name filled with peace and warmth.",
  services_row1_target1: "Age 16+",
  services_row1_target2: "Age 4–15",
  services_row1_target3: "Age 0–3",
  services_row2_target1: "Shop / Company / Business Name",
  services_row3_target1: "Pet Name",
  services_col_target: "Target",
  services_col_price: "Price (tax incl.)",
  services_cta: "Apply for This Service",
  services_includes_title: "What's Included (all within the fee)",
  services_inc1: "Name reading",
  services_inc2: "Optimal ten-ten suggestion",
  services_inc3: "Business-card-size card mailed on request (free)",
  services_inc4: "Advice for good fortune",
  services_inc5: "Photo data of the name card",
  services_includes_note: "A reading to gently draw out the charm already within your name.",
  services_payment_title: "Payment",
  services_payment_method: "Bank Transfer (prepayment)",
  services_payment_desc: "We will provide bank details after your application.\nFrom the moment your payment is complete, the flow of fortune quietly begins to align.",
  services_first_title: "First-Time Visitors",
  services_first_desc: "It is natural to feel uncertain.\nThat feeling is a sign from your heart\nthat it is time to begin a gentle change.",
  services_first_cta: "Start with a Consultation",

  // Flow
  flow_heading: "How It Works",
  flow_step1_title: "Submit the Application Form",
  flow_step1_c1: "Please fill in the required information on the dedicated form.",
  flow_step1_c2: "After submission, you will receive a reply email within 2–3 business days.",
  flow_step1_c3: "The email will include the next steps and bank transfer instructions.",
  flow_step2_title: "Transfer the Reading Fee",
  flow_step2_c1: "Please transfer the reading fee to the account listed in the reply email.",
  flow_step2_c2: "Once confirmed, we will begin preparing your reading in order.",
  flow_step3_title: "Notify Us of Your Transfer",
  flow_step3_c1: "After transferring, please send a photo of your transfer receipt to the address in the email.",
  flow_step3_c2: "Once confirmed, we will send you a \"Registration Complete\" message.",
  flow_step3_note: "Without this notification, we may not be able to begin your reading. Please be sure to send it.",
  flow_step4_title: "Receive Your Reading Results",
  flow_step4_c1: "Within about one week after the reading, we will email you a photo of your name card with ten-ten.",
  flow_step4_c2: "We will then send a detailed reading report and good-fortune advice by email.",
  flow_step5_title: "Mail the Name Card (Optional)",
  flow_step5_c1: "If requested, we will mail a business-card-size name card handwritten by the master.",
  flow_step5_c2: "Please enter your exact mailing address in the address field of the application form.",
  flow_step5_note: "If you do not need the card, entering only your city/town is fine.",
  flow_banner_title: "Fully online. From anywhere in Japan.",
  flow_banner_desc: "No need to travel to Ikei Island in Okinawa.\nYou can start just as you are, without changing your daily life.",
  flow_banner_cta: "Apply Now",

  // Testimonials
  testimonials_heading: "Testimonials",
  testimonials_viewing: "Viewing",

  // FAQ
  faq_heading: "Frequently Asked Questions",
  faq_cta_title: "Still have questions?",
  faq_cta_desc: "Even small things are welcome.\nThe questions you hesitate to ask are exactly the ones we want to hear.",
  faq_cta_btn: "Feel Free to Ask",

  // CTA Banner
  cta_heading1: "Free",
  cta_heading2: "Consultation",
  cta_btn: "Book Now",

  // Contact
  contact_heading: "Contact Us",
  contact_desc: "Please feel free to contact us via this form for reading requests or inquiries. We typically reply within 2–3 business days.",
  contact_address_label: "Address",
  contact_address_value: "Tochigi, Japan (Online · Nationwide)",
  contact_email_label: "Email",
  contact_hours_label: "Hours",
  contact_hours_value: "Weekdays 9:00–18:00 (Closed Sat/Sun/Holidays)",
  contact_note_title: "About Replies",
  contact_note_desc: "Our reply may be sorted into your spam folder.\nIf you have not received a reply after 2–3 business days, please contact us directly by email.",
  contact_field_name: "Full Name",
  contact_field_furigana: "Furigana (Reading)",
  contact_field_email: "Email Address",
  contact_field_phone: "Phone Number",
  contact_field_service: "Desired Service",
  contact_field_message: "Message",
  contact_placeholder_name: "Taro Yamada",
  contact_placeholder_furigana: "ヤマダ タロウ",
  contact_placeholder_email: "example@email.com",
  contact_placeholder_phone: "090-0000-0000",
  contact_placeholder_message: "Please enter the name you would like read, or any questions or requests.",
  contact_select_placeholder: "Please select",
  contact_service1: "Personal Name",
  contact_service2: "Business Name",
  contact_service3: "Pet Name",
  contact_service4: "Other / Consultation",
  contact_submit: "Send",
  contact_submitting: "Sending...",
  contact_privacy: "Personal information submitted will be used only for reading services.",
  contact_error: "Sending failed. Please try again later or contact us directly by email.",
  contact_err_name: "Please enter your name",
  contact_err_email_required: "Please enter your email address",
  contact_err_email_invalid: "Please enter a valid email address",
  contact_err_service: "Please select a service",
  contact_err_message_required: "Please enter your message",
  contact_err_message_limit: "Please keep your message within 500 characters",
  contact_thanks_title: "Message Sent",
  contact_thanks_desc: "Thank you for reaching out.\nWe will review your message and reply within <strong>2–3 business days</strong>.\nPlease wait a moment.",
  contact_thanks_check1: "Please check your confirmation email",
  contact_thanks_check2: "Also check your spam folder",
  contact_thanks_check3: "Please allow 2–3 business days for a reply",
  contact_thanks_another: "Send another message",

  // Footer
  footer_subtitle: "Okinawa Name Reading",
  footer_title: "Tenten-Ojisan Divination",
  footer_desc: "From Okinawa to all of Japan. A name-reading master with over 50 years of experience carefully reads the destiny within your name.",
  footer_contact_title: "CONTACT INFO",
  footer_address_label: "ADDRESS",
  footer_address_value: "Tochigi, Japan\n(Online · Nationwide)",
  footer_email_label: "EMAIL",
  footer_hours_label: "HOURS",
  footer_hours_value: "Weekdays 9:00–18:00\n(Closed Sat/Sun/Holidays)",
  footer_nav_title: "NAVIGATION",
  footer_copyright: "© 2025 Tenten-Ojisan Divination. All rights reserved.",
  footer_privacy: "Privacy Policy",
  footer_law: "Specified Commercial Transactions Act",
  footer_sitemap: "Sitemap",
};

export default en;
